<template>
    <div class="row mb-60px mb-md-100px form-container">
        <form @submit.prevent="submitForm" class="altform corporate">
      <!-- Name -->
          <FormInput
            v-model="form.name"
            :required=false
            @clearError="clearFieldError('name')"
            label="Name"
            placeholder="Name *"
            :errorMessage="errors.name"
          />
        <!-- Company -->
          <FormInput
            v-model="form.company"
            :required=false
            @clearError="clearFieldError('last_name')"
            label="Company"
            placeholder="Company *"
            :errorMessage="errors.company"
          />
        <!-- Email Address -->
        <FormInput
            v-model="form.email"
            @clearError="clearFieldError('email')"
            :required=false
            label="Email"
            placeholder="Email *"
            type="text"
            :rules="[
              { required: 'Please enter your Email' }, 
              { maxLength: 50, message: 'Email cannot be longer than 50 characters' },
              { isEmail: true, message: 'Please enter a valid email address' }
            ]"
            :errorMessage="errors.email"
          />
      
          <!-- Contact Number -->
          <FormInput
            v-model="form.phone"
            :required=false
            @clearError="clearFieldError('phone')"
            label="Contact No"
            placeholder="Contact No *"
            :rules="[
              { required: 'Please enter your Contact number' },
              { pattern: { value: /^[0-9]+$/, message: 'Contact Number cannot contain alphabets' } },
              { minLength: 8, message: 'Length is 8-15 characters.' },
              { maxLength: 15, message: 'Length is 8-15 characters.' }
            ]"
            :errorMessage="errors.phone"
          />

          <!-- Which of the following best describes you? -->
          <FormSelect
            v-model="form.type_of_corporate"
            @clearError="clearFieldError('type_of_corporate')"
            :options="corporateOptions"
            label="Preferred contact method"
            :errorMessage="errors.type_of_corporate"
          />
      
          <!-- State your availability for interview -->
          <FormInput
            v-model="form.message"
            @clearError="clearFieldError('message')"
            label="Message"
            :required=false
            placeholder="What is the occasion, your budget, the quantity or any other info"
            type="textarea"
            :errorMessage="errors.message"
          />
      
          <!-- Notice Period -->
          <FormSelect
            v-model="form.type_of_hear"
            @clearError="clearFieldError('type_of_hear')"
            :options="hearOptions"
            id="type_of_hear"
            label="How did you hear about us?"
            :errorMessage="errors.type_of_hear"
          />
          <!-- Agree to Terms -->
          <FormCheckbox
            v-model="form.item_marketing_consent"
            @clearError="clearFieldError('item_marketing_consent')"
            label="I agree to receive marketing communications from SK Jewellery"
            id="item_marketing_consent"
            :rules="[{ required: 'This field is required' }]"
            :errorMessage="errors.item_marketing_consent"
          />
      
          <!-- Recaptcha -->
  
           <Recaptcha ref="recaptchaRef" v-model="form.recaptcha" :siteKey="siteKey" />
  
          <!-- Submit Button -->
          <div class="altform-submit-group">
            <button :disabled="isSubmitting" type="submit" class="btn button-submit">
              <span class="button__text">
                Submit
              </span>
            </button>
            <div v-if="isSubmitting" class="loading">
              <p></p>
            </div>
          </div>
          <p v-if="responseMessage" class="altform-message" :class="{'success-message': isSuccess, 'text-danger': !isSuccess }">
            {{ responseMessage }}
          </p>
        </form>
    </div>
  
    </template>
    
    <script setup lang="ts">
    import { ref } from 'vue';
    import FormSelect from "@/components/Career/Forms/FormSelect.vue";
    import FormInput from "@/components/Career/Forms/FormInput.vue";
    import FormCheckbox from "@/components/Career/Forms/FormCheckbox.vue";
    import FormFile from '@/components/Career/Forms/FormFile.vue';
    import Recaptcha from '@/components/Career/Forms/Recaptcha.vue';
    import Heading from '@/components/Heading.vue';
    const { $ajax, $file } = useNuxtApp();
    const userStore = useUserStore();
    const siteKey = ref('')
    interface FormResponse {
      success: boolean;
      data: any;
    }
    interface FormState {
      post_id : number;
      form_id: string;
      company: string;
      name: string;
      phone: string;
      email: string;
      type_of_hear: string;
      type_of_corporate: string;
      message: string;
      item_marketing_consent: boolean;
      recaptcha: string;
    }
    
    // Initialize form state with types
    const form = ref<FormState>({
      post_id : 590776,
      form_id: 'corporate-gifts',
      name : '',
      company: '',
      phone: '',
      email: '',
      type_of_hear: '',
      type_of_corporate: '',
      message:'',
      item_marketing_consent: true,
      recaptcha: ''
    });
  
    const errors = ref<{ [key: string]: string | null }>({
      name: null,
      company: null,
      phone: null,
      email: null,
      type_of_hear: null,
      type_of_corporate: null,
      message: null,
      item_marketing_consent: null,
      recaptcha: null,
    });
    
    // Describes Options (Replace this with actual data fetching)
    const corporateOptions = ref<{ value: string; label: string }[]>([
      { value: 'referral', label: 'Referral' },
      { value: 'google', label: 'Google' },
      { value: 'customer', label: 'Current customer' },
      { value: 'gift', label: 'Received a gift' },
      { value: 'others', label: 'Others' },
    ]);
    
    // Notice Period Options (Replace this with actual data fetching)
    const hearOptions = ref<{ value: string; label: string }[]>([
      { value: 'email', label: 'Email' },
      { value: 'Phone', label: 'Phone' }
    ]);
    
    const isSubmitting = ref(false);
    const responseMessage = ref('');
    const isSuccess = ref(false);
    const name = form.value.name;
    // Reference to the Recaptcha component
    const recaptchaRef = ref(null);
    // Functions to fetch data (departments, employment types, and jobs)
    const fetchOptions = async () => {
      // Fetch jobs based on filters
      try {
        const response = await $file.get<FormResponse>('career/form-data.json');
  
        if (response.success == true) {
          siteKey.value = response.data.site_key
        } else {
        console.error('Failed to fetch data: API response indicates failure');
        // Optionally, you can set an error state or display an error message to the user
          }
        } catch (error) {
          console.error('An error occurred while fetching data:', error);
          // You can set an error state here or notify the user
        } finally {

          }
    };
  
  // Validation logic
  const validateForm = () => {
    let isValid = true;

    // Reset all error messages
    for (const key in errors.value) {
      errors.value[key] = null;
    }
    // Validate required fields
    if (!form.value.name) {
    errors.value.name = 'Please enter your name';
    isValid = false;
      } else if (!/^[A-Za-z ]+$/.test(form.value.name)) {
        errors.value.name = 'Name cannot contain numbers';  
        isValid = false;
      }
  
    if (!form.value.company) {
      errors.value.company = 'Please enter your Last name';
      isValid = false;
    } else if (!/^[A-Za-z ]+$/.test(form.value.company)) {
      errors.value.company = 'Name cannot contain numbers';
      isValid = false;
    }
    if (!form.value.phone) {
      errors.value.phone = 'Please enter your Contact number';
      isValid = false;
    } else if (!/^[0-9]+$/.test(form.value.phone)) {
      errors.value.phone = 'Contact Number cannot contain alphabets';
      isValid = false;
    } else if (form.value.phone.length < 8) {
      errors.value.phone = 'Length is 8-15 characters.';
    } else if (form.value.phone.length > 15) {
      errors.value.phone = 'Length is 8-15 characters.';
    }
    if (!form.value.email) {
      errors.value.email = 'Please enter your Email';
      isValid = false;
    } else if (!/^\S+@\S+\.\S+$/.test(form.value.email)) {
      errors.value.email = 'Please enter a valid email address';
      isValid = false;
    } else if (form.value.email.length > 50) {
      errors.value.email = 'Email cannot exceed 50 characters';
    }
    if (!form.value.type_of_hear) {
      errors.value.describes = 'Please select an option';
      isValid = false;
    }
    if (!form.value.type_of_corporate) {
      errors.value.interview = 'Please select a date';
      isValid = false;
    }
  
    return isValid;
  };
  
  const submitForm = async () => {
    responseMessage.value = '';
    if (isSubmitting.value) return;
  
    const isValid = validateForm();
    if (!isValid) {
      responseMessage.value = 'Please enter all required fields'
      return;
    }
      // Trigger reCAPTCHA token generation in child component
      if (recaptchaRef.value){
        recaptchaRef.value.getToken();
      }
      
      if (!form.value.recaptcha) {
        return;
      }
      try {
      isSubmitting.value = true; 
  
        // Create FormData object
        const formData = new FormData();
  
        // Append all form fields to FormData object
        for (const key in form.value) {
          const value = form.value[key as keyof FormState];
          formData.append(key, String(value));  // Append other form fields as strings
        }
  
        // Make POST request with FormData
        const response = await $ajax.post('wp-json/skj/v1/submit_kform', formData, {
          headers: {
            // Do not manually set 'Content-Type'; browser will set it with correct boundary
            'Accept': 'application/json',
            'Authorization': `Bearer ${userStore.csrf}`
          }
        });
  
        isSuccess.value = true;
        responseMessage.value = response.message || 'Thank you for your submission.';
      } catch (error) {
        // Handle error response
        isSuccess.value = false;
        responseMessage.value = error.message || 'An error occurred. Please try again.';
        
        recaptchaRef.value.getToken();
        setTimeout(async () => {
          submitForm();
        }, 1000);
      }finally {
        isSubmitting.value = false;
      }
    };
  
    const clearFieldError = (field: string) => {
      errors.value[field] = null;
    };
  
    watch(form, (newValue, oldValue) => {
      for (const key in newValue) {
        if (newValue[key as keyof FormState] !== oldValue[key as keyof FormState]) {
          errors.value[key] = '';  // Clear error message for the changed field
        }
      }
    }, { deep: true });
  
  onMounted(() => {
    fetchOptions();
  });
  </script>
  <style lang="scss">
    @import "@/assets/scss/components/career/joblist";
    @import "@/assets/scss/components/career/kforms";
    input.dp__input{
      padding-inline-start: 0;
    }
    .dp__menu.dp__menu_index{
      border-radius: 10px;
    }
    .dp__active_date{
      background-color: #AD073D !important;
      color: #fff !important;
      border: none;
    }
    .dp__calendar_header{
      font-weight: 400
    }
    .dp__calendar_row{
      margin-top: 0;
      margin-bottom: 0;
    }
    .dp__menu_inner{
      box-shadow: 0px 3px 10px 0 #D4CFD0;
      border-radius: 10px;
    }
    .dp__input_icon{
      right: 2px;
      left: auto;
    }
    .dp--clear-btn {
      right: 20px;
    }
  </style>


